// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React, {useCallback} from 'react';
import cn from 'classnames';
import date from '/util/date.js';
import statuses from '/svc/wbm/pub/earnapp_util.js';
import {DATE_TIME_FMT, DATE_FMT_SHORT, METHODS, P_METHOD_META,
    EXECUTION_DURATIONS} from '../../utils/constants.js';
import {fmt_money} from '../../utils/misc.js';
import store from '../../store.js';
import {Text} from '../../comp/text';
import {TH, TR, TD, Table} from '../../comp/table';
import './transactions_table.less';

const PAGE_SIZE = 20;

const fmt = (d, time=false)=>
    date.strftime(time ? DATE_TIME_FMT : DATE_FMT_SHORT, d);

const get_est_date = redeem=>{
    let mult;
    if (!(mult = EXECUTION_DURATIONS[redeem.payment_method]))
        mult = EXECUTION_DURATIONS[METHODS.AMAZON];
    const days = Math.ceil(mult*1.2);
    return date.add(redeem.date, {days});
};

const show_est = status=>{
    switch (status)
    {
    case statuses.STATUS_PAID:
    case statuses.STATUS_CANCELED:
    case statuses.STATUS_REJECTED:
    case statuses.STATUS_NOT_PAID:
        return false;
    default:
        return true;
    }
};

const render_paid = redeem=>{
    let content;
    let title;
    if (show_est(redeem.status))
    {
        content = `est. ${fmt(get_est_date(redeem))}`;
        title = 'Estimated payment date';
    }
    else if (redeem.payment_date)
    {
        content = fmt(redeem.payment_date);
        title = fmt(redeem.payment_date, true);
    }
    return <Text.s mono tip={title} no_wrap>{content}</Text.s>;
};

const render_status = status=>{
    let color;
    let tip;
    let text;
    switch (status)
    {
    case statuses.STATUS_PAID:
        text = 'Paid';
        color = 'success';
        tip = 'Transaction is completed';
        break;
    case statuses.STATUS_CANCELED:
    case statuses.STATUS_REJECTED:
    case statuses.STATUS_NOT_PAID:
        text = 'Failed';
        color = 'error';
        tip = `This transaction has been rejected. For more
            information contact support.`;
        break;
    case statuses.STATUS_CREATED:
    case statuses.STATUS_APPROVED:
    case statuses.STATUS_PENDING_PAID:
    case statuses.STATUS_PENDING_PROCEDURE:
        text = 'In process';
        color = 'warning';
        tip = 'Transaction in process';
        break;
    }
    const classes = `eatt_status eatt_status__${color}`;
    return <Text.s tip={tip} tip_placement="left" no_wrap ghost
      className={classes}>
      {text}
    </Text.s>;
};

const get_amount_title = t=>{
    let title = '';
    if (t.ref_bonuses_amount)
    {
        title = `including ${
            fmt_money(t.ref_bonuses_amount)} from my referrals`;
    }
    if (t.promo_bonuses_amount)
    {
        title += title ? ' and ' : 'including ';
        title += `${fmt_money(t.promo_bonuses_amount)} from promotions`;
    }
    if (t.ref_bvpn_amount)
    {
        title += title ? ' and ' : 'including ';
        title += `${fmt_money(t.ref_bvpn_amount)} from Bright VPN referrals`;
    }
    if (t.ref_hola_browser_amount)
    {
        title += title ? ' and ' : 'including ';
        title += `${fmt_money(t.ref_hola_browser_amount)} from`
            +' Hola Browser referrals';
    }
    return title;
};

function Table_header(){
    return <>
      <TH left>Transaction ID</TH>
      <TH left>Email</TH>
      <TH>Amount</TH>
      <TH>Fee</TH>
      <TH>Requested</TH>
      <TH>Paid</TH>
      <TH>Method</TH>
      <TH>Status</TH>
    </>;
}

function Row({data: d}){
    return <TR className="eatt_row">
      <TD left>
        <Text.s mono no_wrap>{d.uuid}</Text.s>
      </TD>
      <TD no_wrap left>
        <Text.s>{d.email}</Text.s>
      </TD>
      <TD>
        <Text.s mono no_wrap tip={get_amount_title(d)}>
          {fmt_money(d.money_amount)}
        </Text.s>
      </TD>
      <TD>
        <Text.s mono no_wrap>{fmt_money(d.fee_amount||0)}</Text.s>
      </TD>
      <TD>
        <Text.s mono no_wrap tip={fmt(d.date, 1)}>{fmt(d.date)}</Text.s>
      </TD>
      <TD>
        {render_paid(d)}
      </TD>
      <TD>
        <Text.s no_wrap>
          {P_METHOD_META[d.payment_method]?.title || d.payment_method}
        </Text.s>
      </TD>
      <TD>
        {render_status(d.status)}
      </TD>
    </TR>;
}

export function Transactions_table({className}){
    const [{list},, loading] = store.use_transactions();
    const render_row = useCallback(t=><Row key={t.uuid} data={t}/>, []);
    return <div className={cn('ea_transactions_table', className)}>
      <Text.xxl h2>Transactions</Text.xxl>
      <Table header={<Table_header/>} list={list} loading={loading}
        render_row={render_row} id_key="uuid" page_size={PAGE_SIZE}/>
    </div>;
}
